module.exports = __webpack_public_path__ + "img/safari-step-3.c1104d42.png";